/* eslint-disable jsx-a11y/alt-text */

import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel } from "swiper/modules";
import Pagination from "./components/pagination";
import { AUTO_TEXTS } from "./constants/main";
import { galleryItems } from "./constants/gallery";
import useMediaQuery from "./utils/use-media-query";
import Section2 from "./sections/section2";
import Section5 from "./sections/section5";
import Section8 from "./sections/section8";
import Section7 from "./sections/section7";
import Section9 from "./sections/section9";
import Section10 from "./sections/section10";
import useTextAnimation from "./utils/use-text-animation";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/mousewheel";
import "swiper/css/effect-fade";

const PREVENT_SCROLL_TIME = 700;

export const mousewheel = {
  enabled: true,
  // forceToAxis: true,
  releaseOnEdges: true,
  sensitivity: 0.5,
  thresholdDelta: 10,
};

const Content = () => {
  const [parentSwiper, setSwiper] = useState();
  const [activeIndex, setActiveIndex] = useState(0);

  const handlePreventScroll = (childSwiper) => {
    if (!parentSwiper) return;

    childSwiper.disable();
    parentSwiper.disable();

    setTimeout(() => {
      childSwiper.enable();
      const isInnerSwiperProgress =
        childSwiper.isBeginning || childSwiper.isEnd;
      if (isInnerSwiperProgress) parentSwiper.enable();

      parentSwiper.update();
      childSwiper.update();
    }, PREVENT_SCROLL_TIME);

    const header = document.getElementById("header");
    if (header) {
      const isDown =
        childSwiper.previousIndex < childSwiper.activeIndex ||
        parentSwiper.previousIndex < parentSwiper.activeIndex;
      header.className = `header has-bg is-current${
        isDown ? " is-rollup" : ""
      }`;
    }

    setActiveIndex(parentSwiper.activeIndex);
  };

  useMediaQuery();
  useTextAnimation(activeIndex);

  return (
    <>
      <Swiper
        direction="vertical"
        slidesPerView="auto"
        observeSlideChildren
        speed={700}
        mousewheel={mousewheel}
        modules={[Mousewheel]}
        preventInteractionOnTransition
        updateOnWindowResize
        onSwiper={setSwiper}
        onSlideChangeTransitionStart={handlePreventScroll}
      >
        <SwiperSlide className="section" data-section="1">
          <div className="main">
            <div className="locknlock_intro">
              <video className="video_bg" autoPlay muted playsInline loop>
                <source
                  src="//www.locknlock.com/eng/image/common/about/brand/video_brand_pc.mp4"
                  type="video/mp4"
                  media="(min-width: 768px)"
                />
                <source
                  src="//www.locknlock.com/eng/image/common/about/brand/video_brand_mob.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide className="section introduce_box" data-section="2">
          <Section2 onSlideChange={handlePreventScroll} />
        </SwiperSlide>

        <SwiperSlide className="section" data-section="3">
          <div className="bg_box">
            <picture className="section_bg">
              <source
                srcSet="//www.locknlock.com/eng/image/common/about/brand/img_introduction_pc.png"
                media="(min-width: 768px)"
              />
              <img src="//www.locknlock.com/eng/image/common/about/brand/img_introduction_mob.png" />
            </picture>
            <div className="container">
              <div className="text_wrap">
                <p className="bg_title animated_text">Lockin’ Your Moment</p>
                <p className="bg_desc animated_text delay">
                  With LocknLock’s trusted technology, we securely
                  <br />
                  protect your most precious moments—helping them
                  <br />
                  stay fresh, meaningful, and enduring.
                </p>
              </div>
            </div>
            <div className="dim" />
          </div>
        </SwiperSlide>

        <SwiperSlide className="section scroll_box" data-section="4">
          <picture className="section_bg">
            <source
              srcSet="//www.locknlock.com/eng/image/common/about/brand/img_scroller_pc.png"
              media="(min-width: 768px)"
            />
            <img src="//www.locknlock.com/eng/image/common/about/brand/img_scroller_mob.png" />
          </picture>
          <div className="container texts">
            {[...AUTO_TEXTS, ...AUTO_TEXTS].map((text, i) => (
              <div key={`${text}_${i}`}>{text}</div>
            ))}
          </div>
        </SwiperSlide>

        <SwiperSlide className="section" data-section="5">
          <Section5 onSlideChange={handlePreventScroll} />
        </SwiperSlide>

        <SwiperSlide className="section" data-section="6">
          <div className="main">
            <div className="locknlock_intro">
              <video className="video_bg" autoPlay muted playsInline loop>
                <source
                  src="//www.locknlock.com/eng/image/common/about/brand/video_logoplay_pc.mp4"
                  media="(min-width: 768px)"
                  type="video/mp4"
                />
                <source
                  src="//www.locknlock.com/eng/image/common/about/brand/video_logoplay_mob.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
        </SwiperSlide>

        <SwiperSlide className="section" data-section="7">
          <Section7
            isActive={activeIndex === 6}
            onSlideChange={handlePreventScroll}
          />
        </SwiperSlide>

        <SwiperSlide className="section" data-section="8">
          <Section8 onSlideChange={handlePreventScroll} />
        </SwiperSlide>

        <SwiperSlide className="section" data-section="9">
          <Section9 onSlideChange={handlePreventScroll} />
        </SwiperSlide>

        <SwiperSlide className="section" data-section="10">
          <Section10
            isActive={activeIndex === 9}
            onSlideChange={handlePreventScroll}
          />
        </SwiperSlide>

        <SwiperSlide className="section fit_height" data-section="11">
          <ul className="gallery_box">
            {galleryItems.map(({ title, content, imageUrl }, i) => (
              <li key={`gallery_${i}`} className="gallery_item">
                <img
                  src={imageUrl}
                  className="inner_bg lazy"
                  decoding="async"
                />
                <div className="gallery_item_info">
                  <p className="item_title">{title}</p>
                  <p className="item_desc">{content}</p>
                </div>
              </li>
            ))}
          </ul>
        </SwiperSlide>
      </Swiper>

      <Pagination activeIndex={activeIndex} swiper={parentSwiper} />
    </>
  );
};

export default Content;
